/**
 * The super-admin area is an internal tool designed in a light theme, while the rest of the app
 * defaults to dark. Forcing the light theme on these routes puts the `light` class on <html>, so
 * every design token, `dark:` variant, portaled popover and native control agrees with the page.
 * Overriding a few tokens on a wrapper left borders, inputs, badges and dialogs on dark values.
 */
const SUPER_ADMIN_PATH = '/super-admin';

export const SUPER_ADMIN_THEME = 'light';

export function isSuperAdminPath(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false;
  }
  return pathname === SUPER_ADMIN_PATH || pathname.startsWith(`${SUPER_ADMIN_PATH}/`);
}
